<div class="container">
    <h2>Legal notice</h2>
    <section class="M-TextTwo" aria-label="copyright">
        <div class="M-TextTwo__body">
            <p class="M-TextTwo__intro-text"><strong>Copyright (©)</strong></p>
            <div class="M-TextTwo__description">
                <div class="A-Text-RichText">
                    <p>All the content of this website (especially text, images, graphics, sound, animations, and
                        videos) and the positioning thereof in Bosch websites is subject to copyright protection and to
                        other protection laws. Without the consent of the respective rights owner, the content of these
                        websites may not be copied, disseminated, modified, or made accessible to third parties for
                        commercial purposes.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="M-TextTwo" aria-label="trademark">
        <div class="M-TextTwo__body">
            <p class="M-TextTwo__intro-text"><strong>Trademarks</strong></p>
            <div class="M-TextTwo__description">
                <div class="A-Text-RichText">
                    <p>Unless otherwise indicated, the trademarks used on our sites are the intellectual property of
                        Robert Bosch GmbH, Germany.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="M-TextTwo" aria-label="licences">
        <div class="M-TextTwo__body">
            <p class="M-TextTwo__intro-text"><strong>No license</strong></p>
            <div class="M-TextTwo__description">
                <div class="A-Text-RichText">
                    <p>No license to use the intellectual property (in particular the patents, trademarks, and
                        copyrights) of companies in the Bosch Group (Bosch) or of third parties is granted by way of
                        this website.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="M-TextTwo" aria-label="onlinedisputeresolution">
        <div class="M-TextTwo__body">
            <p class="M-TextTwo__intro-text"><strong>Information on Online Dispute Resolution</strong></p>
            <div class="M-TextTwo__description">
                <div class="A-Text-RichText">
                    <p>The European Commission has set up a platform for Online Dispute Resolution (ODR). This platform
                        is intended to serve as a point of contact for the out-of-court resolution of disputes relating
                        to contractual obligations under online sales contracts and online service contracts.</p>
                    <p>The platform is provided at <a target="_blank"
                            aria-label="http://ec.europa.eu/consumers/odr/ opens external site"
                            rel="noopener, noreferrer"
                            href="http://ec.europa.eu/consumers/odr/"><span>http://ec.europa.eu/consumers/odr/<i
                                    class="a-icon ui-ic-nosafe-lr-externallink"></i></span></a>.</p>
                    <p>Robert Bosch GmbH does not participate in dispute resolution proceedings before consumer
                        arbitration bodies.</p>
                </div>
            </div>
        </div>
    </section>
</div>